import { AxiosResponse } from 'axios';
import { all, AllEffect, call, CallEffect, ForkEffect, put, PutEffect, takeLatest } from 'redux-saga/effects';
import {
  requestApiSaga,
  retryRequestApiSaga,
} from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { Details } from 'b2b-apps/shop/myAccount/accountDetails/api/Details';
import {
  MY_ACCOUNT_MESSAGE,
  showMyAccountToast,
} from 'b2b-apps/shop/myAccount/common/utils/messages';
import {
  clearAccountDetails,
  fetchDetailsFulfilled,
  fetchDetailsRejected,
} from './actionCreators';
import { FETCH_DETAILS, UPDATE_CONTACT_INFORMATION } from './actionTypes';
import {
  DetailsType,
  FetchDetailsAction,
  UpdateContactInformationAction,
} from './types';

function* fetchDetailsSaga(
  action: FetchDetailsAction,
): Generator<CallEffect | PutEffect, any, AxiosResponse<DetailsType>> {
  try {
    const response = yield call(retryRequestApiSaga, Details.fetch());
    yield put(fetchDetailsFulfilled(response.data));
  } catch (error) {
    yield put(fetchDetailsRejected(parseError(error)));
    yield put(reportError(action.type, error));
  }
}

function* updateContactInformationSaga(
  action: UpdateContactInformationAction,
): Generator<CallEffect | PutEffect, any, AxiosResponse> {
  const { contactInformation, callback } = action.payload;

  try {
    yield call(
      requestApiSaga,
      Details.updateContactInformation(contactInformation),
    );
    yield put(clearAccountDetails());
    showMyAccountToast(MY_ACCOUNT_MESSAGE.successEditContactInformation);
    callback(true);
  } catch (error) {
    showMyAccountToast(MY_ACCOUNT_MESSAGE.errorEditContactInformation);
    callback(false);
    yield put(reportError(action.type, error));
  }
}

function* detailsSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([
    takeLatest(FETCH_DETAILS, fetchDetailsSaga),
    takeLatest(UPDATE_CONTACT_INFORMATION, updateContactInformationSaga),
  ]);
}

export {
  detailsSaga,
};
